import BusinessLogo from "../../../assets/images/logo.png";

const NextPublicGlobalLoader = () => {
  return (
    <div className="h-screen w-screen">
      <div className="layer-global-loader-public next-global-loader items-center">
        <img alt="logo loader" src={BusinessLogo} className="my-auto mx-auto" />
      </div>
    </div>
  );
};

export default NextPublicGlobalLoader;
